import React from "react"
import { Image, Nav, Navbar } from "react-bootstrap"
import logo from "../images/logo.png"
import { GoLinkExternal  } from "react-icons/go"

const style = {
  fontSize: "16px",
  paddingTop: "0",
  paddingBottom: "0",
  paddingLeft: "10px",
  paddingRight: "10px",
  fontWeight: 600,
  color: "rgb(228, 230, 235)",
}

const Header = () => (
  <Navbar
    bg="#18191A"
    variant="dark"
    expand="md"
    sticky="top"
    style={{ padding: 0, backgroundColor: "#242526" }}
  >
    <Navbar.Brand href="/">
      <div style={{ flexDirection: "row" }}>
        <img
          src={logo}
          alt=""
          height="60"
          width="60"
          style={{
            marginTop: "15px",
            marginBottom: "15px",
            marginLeft: "15px",
            borderRadius: "20px",
          }}
        />
        <a
          style={{
            color: "rgb(176, 179, 184)",
            font: "8px",
            margin: "0",
            paddingLeft: "3px",
          }}
        >
          POLLEUX LAB
        </a>
      </div>
    </Navbar.Brand>
    <Navbar.Toggle
      aria-controls="responsive-navbar-nav"
      style={{ marginRight: "30px" }}
    />
    <Navbar.Collapse
      id="responsive-navbar-nav"
      style={{ justifyContent: "flex-end", paddingRight: "0px" }}
    >
      <Nav
        style={{ justifyContent: "flex-end", paddingRight: "0px"}}
      >
        <Nav.Link href="/#research" style={style} eventKey="Reasearch">
          RESEARCH
        </Nav.Link>
        <Nav.Link href="/#people" style={style} eventKey="People">
          TEAM
        </Nav.Link>
        <Nav.Link href="/#tools" style={style} eventKey="Tools">
          TOOLS
        </Nav.Link>
        <Nav.Link href="/#publications" style={style} eventKey="News">
          NEWS
        </Nav.Link>
        <Nav.Link href="/publications2" style={style} eventKey="Publications">
          PUBLICATIONS
        </Nav.Link>
        <Nav.Link href="/#funders" style={style} eventKey="Positions">
          FUNDERS
        </Nav.Link>
        <Nav.Link href="/contact" style={style} eventKey="Contact">
          CONTACT
        </Nav.Link>
      </Nav>
    </Navbar.Collapse>
  </Navbar>
)

export default Header
/*
 <Nav.Link href="/publications" style={style} eventKey="Publications">
          PUBLICATIONS 1
        </Nav.Link>
*/
